import React from 'react';
import styles from './SteelTable.module.css';

const SteelTable = ({ data, title }) => {
  // Проверяем, что данные существуют
  if (!data || data.length === 0) {
    console.log('Ошибка: Нет данных для отображения таблицы');
    return null;
  }

  // Получаем заголовки из первого объекта
  const headers = Object.keys(data[0]);

  return (
    <div className={styles.tableContainer}>
      <h2 className={styles.tableTitle}>{title}</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.steelTable}>
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {headers.map((header, colIndex) => (
                  <td key={`${rowIndex}-${colIndex}`}>{row[header]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SteelTable; 